module.exports = __webpack_public_path__ + "assets/ic_cart_plus-ec7b97.svg";